import React from 'react';
import styles from './styles.module.scss';
import { RemoveIcon } from 'components/common/icons';
import { Space, Button, Row, Col, Typography, HasAccess } from 'components';
import { PERMISSIONS } from '../../../../constants/permissions';

interface BrandPanelHeaderProps {
  brandName: string;
  rejected: boolean;
  onClick: (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => void;
}

export const BrandPanelHeader: React.FC<BrandPanelHeaderProps> = ({ brandName, rejected, onClick }) => (
  <Row className={styles.brandName}>
    <Col onClick={onClick} style={{ maxWidth: '600px' }}>
      <Typography.Text style={{ maxWidth: 600 }} ellipsis={{ tooltip: true }}>
        {brandName}
      </Typography.Text>
    </Col>
    {rejected && (
      <Col style={{ maxWidth: '70px' }} className={styles.rejectedBadge}>
        Rejected
      </Col>
    )}
  </Row>
);

interface BrandPanelProps {
  brandId: string;
  brandName: string;
  reason: string;
  rejected: boolean;
  isFinalStatus: boolean;
  onBrandClick: (brandId: string) => void;
  onReject: (brandId: string) => void;
  onDelete: (brandId: string) => void;
}

export const BrandPanel: React.FC<BrandPanelProps> = ({
  brandId,
  brandName,
  rejected,
  isFinalStatus,
  reason,
  onBrandClick,
  onReject,
  onDelete,
}) => (
  <div className={styles.brandPanel}>
    <Row justify={'space-between'}>
      <Col flex={'700px'}>
        <BrandPanelHeader
          brandName={brandName}
          rejected={rejected}
          onClick={(e) => {
            e.stopPropagation();
            onBrandClick(brandId);
          }}
        />
        {rejected && <Typography.Text type="secondary">Rejection Reason: {reason}</Typography.Text>}
      </Col>
      <HasAccess role={PERMISSIONS.leads.lead.write}>
        <Col flex={'150'} style={{ textAlign: 'right' }}>
          {!isFinalStatus && (
            <Space>
              {!rejected && (
                <Button
                  type={'default'}
                  className={styles.reject_button}
                  onClick={(e) => {
                    e.stopPropagation();
                    onReject(brandId);
                  }}
                >
                  Reject
                </Button>
              )}
              <Button
                icon={<RemoveIcon />}
                type="link"
                style={{ marginTop: rejected ? 6 : 'unset' }}
                onClick={(e) => {
                  e.stopPropagation();
                  onDelete(brandId);
                }}
              />
            </Space>
          )}
        </Col>
      </HasAccess>
    </Row>
  </div>
);
